import Slider from './modules/Slider.ts';
import KV from './modules/KV.ts';

$(function () {
	new KV().init();
	new Slider('.slide1').init();
	new Slider('.slide2').init();

	$('.header a').click(e => {
		ga('send', 'pageview', '/201610/sp/index_btn.html');
		ga('officialTracker.send', 'pageview', '/201610/sp/index_btn.html');
	});

	$('.btns a').click(e => {
		const name = $(e.currentTarget).attr('class');
		if (name == 'location') {
			ga('send', 'pageview', '/201610/sp/location_btn.html');
			ga('officialTracker.send', 'pageview', '/201610/sp/location_btn.html');
		} else if (name == 'SP') {
			ga('send', 'pageview', '/201610/sp/other_btn.html');
			ga('officialTracker.send', 'pageview', '/201610/sp/other_btn.html');
		} else {
			const url = '/201610/sp/showroom_' + name + '_btn.html';
			ga('send', 'pageview', url);
			ga('officialTracker.send', 'pageview', url);
		}
	});
	
	$('.note').on('click', 'a.plus', e => {
		let isON = $(e.target).parent().toggleClass('ON').hasClass('ON');
		if (isON) ga('send', 'event', 'PS', 'open');
		else ga('send', 'event', 'PS', 'close');
	});

	var player;
	window.onYouTubeIframeAPIReady = () => {
		player = new YT.Player('ytplayer', {
			width: '100%',
			height: '100%',
			videoId: 'yc0BbxkcoIQ',
			playerVars: { 
				'autoplay': 0,
				'controls': 1,
				'autohide': 1,
				'enablejsapi': 1,
				'loop': 0,
				'disablekb': 1,
				'fs': 0,
				'modestbranding': 0,
				'showinfo': 0,
				'rel':0
			},
			events: {
				'onReady': onPlayerReady,
				'onStateChange': onPlayerStateChange
			}
		});
	}
	function onPlayerReady(e) {
		ga('send', 'event', 'YouTube', 'ready');
	}
	function onPlayerStateChange(e) {
		let state;
		switch (e.data) {
			case -1: state = 'unstarted'; break;
			case 0: state = 'ended'; break;
			case 1:
				state = 'playing'; 
				ga('send', 'pageview', '/201610/sp/video_btn.html');
				ga('officialTracker.send', 'pageview', '/201610/sp/video_btn.html');
				break;
			case 2: state = 'paused'; break;
			case 3: state = 'buffering'; break;
			case 5: state = 'video cued'; break;
		}
		if (!!state) ga('send', 'event', 'YouTube', 'state_change', state);
		else ga('send', 'event', 'YouTube', 'state_change', e.data);
	}
	if (YT.loaded) onYouTubeIframeAPIReady();
});


/** WEBPACK FOOTER **
 ** ./src/scripts/main.js
 **/